<template>
  <form class="form-container">
    <slot></slot>
  </form>
</template>

<script setup>
import { ref, provide } from 'vue'
import LGSdk from '@/packages/plugins/languageSDK/index'

const props = defineProps({
  model: {
    type: Object,
    required: true
  },
  rules: {
    type: Object,
    default: () => ({})
  }
})

// const emit = defineEmits(['update:model'])

const errorFields = ref({})
const formItems = ref([])

// 校验单个表单项
const validateField = async (fieldName) => {
  const rule = props.rules[fieldName]
  let message = ''
  let customMessage = ''
  let isValid = true
  if (!rule) return { message, customMessage, isValid }

  const value = props.model[fieldName]

  // 必填校验
  if (rule.required) {
    if (value === undefined || value === null || value === '' || (Array.isArray(value) && !value.length)) {
      isValid = false
      message = rule.message || LGSdk.t('survey.isRequired')
    }
  }

  // 自定义校验函数
  if (isValid && rule.validator) {
    try {
      await rule.validator(value, props.model)
    } catch (err) {
      isValid = false
      customMessage = err?.message || ''
      if (err?.isShowValidate) {
        message = err?.message || ''
        customMessage = ''
      }
    }
  }

  if (message) {
    errorFields.value[fieldName] = message
  } else {
    delete errorFields.value[fieldName]
  }
  return { message, customMessage, isValid }
}

// 校验整个表单
const validate = async () => {
  let isValid = true
  const errors = {}

  let customMessage = ''
  // 校验所有注册的表单项
  for (const item of formItems.value) {
    const fieldValid = await validateField(item.fieldName)
    if (!fieldValid.isValid) {
      isValid = false
      errors[item.fieldName] = errorFields.value[item.fieldName]
      if (!customMessage && fieldValid.customMessage) {
        customMessage = fieldValid.customMessage
      }
    }
  }

  // 如果有错误且需要自动滚动
  if (!isValid) {
    scrollToFirstError()
  }

  return { isValid, customMessage }
}

// 滚动到第一个错误项
const scrollToFirstError = () => {
  if (formItems.value.length === 0) return

  // 找到第一个错误的表单项
  const firstErrorItem = formItems.value.find((item) => errorFields.value[item.fieldName])

  if (firstErrorItem && firstErrorItem.$el) {
    // 平滑滚动到错误项
    firstErrorItem.$el.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    })
  }
}

// 向子组件提供上下文
provide('formContext', {
  model: props.model,
  rules: props.rules,
  errorFields,
  registerItem: (item) => {
    formItems.value.push(item)
  },
  unregisterItem: (item) => {
    formItems.value = formItems.value.filter((i) => i !== item)
  },
  validateField: (filedName) => validateField(filedName)
})

defineExpose({
  validate,
  reset: () => {
    errorFields.value = {}
  }
})
</script>

<style scoped>
.form-container {
  display: flex;
  flex-direction: column;
  word-break: normal;
  overflow-wrap: break-word;
}

.form-item-label,
.radio-label,
.checkbox-label,
.option-label {
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}
</style>
